import React from 'react';
import fruride from '../../../assets/images/fluoride.png'
import cavity from '../../../assets/images/cavity.png'
import teeth from '../../../assets/images/whitening.png'
import Service from '../Service/Service';


const Services = () => {

    const serviceData = [
        {
            id: 1,
            name: 'Fluoride Treatment',
            description: 'Dentists provide professional fluoride treatments in the form of a highly concentrated rinse, foam, gel, or varnish.',
            img: fruride,

        },
        {
            id: 2,
            name: 'Cavity Filling',
            description: 'To treat a cavity your dentist will remove the decayed portion of the tooth and then "fill" the area on the tooth where the decayed material was removed.',
            img: cavity,

        },
        {
            id: 3,
            name: 'Teeth Whitening',
            description: 'Teeth Whitening is a quick and painless in-office whitening system that provides dramatic results—teeth that are up to eight shades whiter!',
            img: teeth,

        },
    ]

    return (
        <div className="">
            <div className=" my-5">
                <h1 className='text-center text-info font-semibold lg:text-3xl'>Our services</h1>
                <h2 className='lg:text-5xl text-center font-semibold'>Services We Provide</h2>

            </div>
            <div className='lg:grid grid-cols-3 gap-3'>
            {
                serviceData.map(service=>
                <Service
                key={service.id}
                service={service}
                >
                </Service>)
            }

        </div>
        </div>
    );
};

export default Services;